

<template>

  <!-- Add Podcast Modal -->
  <div class="modal fade" id="podcastCatModal">
    <div class="modal-dialog modal-dialog-centered custom-modal-two">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div class="modal-header border-0 custom-modal-header">
              <div class="page-title">
                <h4>Podcast Category</h4>
              </div>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <form @submit.prevent="submitForm">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="input-blocks">
                      <label>Category Name</label>
                      <input type="text" name="name" required v-model="podcastCategory.name"
                             :class="{ 'form-control': true }" />
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="input-blocks">
                      <label>Description</label>
                      <input type="text" name="description" required v-model="podcastCategory.description"
                             :class="{ 'form-control': true }" />

                    </div>
                  </div>
                </div>
                <div class="modal-footer-btn">
                  <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal">
                    Cancel
                  </button>
                  <button type="submit" class="btn btn-submit" id="submit">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Podcast Modal -->

</template>

<script setup>

import { usePodcastCategoryStore } from '@/store/podcastCategoryStore';
import { usePlanStore } from '@/store/planStore';
import { checkInputValidity } from '@/utils/validator';
import { computed, onMounted, reactive, ref, watch } from 'vue';
// stores
const podcastCategoryStore = usePodcastCategoryStore();

const props = defineProps({
  categoryId: null
});
// data
const podcastCategory = ref({
  name: '',
  description: null,
});


async function submitForm() {
  if (props.categoryId) {
    // update
    await podcastCategoryStore.updatePodcastCategory(props.categoryId, podcastCategory.value);
  } else {
    // add
    await podcastCategoryStore.addPodcastCategory(podcastCategory.value);
  }
  $("#podcastCatModal").modal("hide");
}

watch(() => podcastCategory, () => {
  // setTimeout is used here so the plan will be passed to the input b4 this runs
  setTimeout(() => (
      checkInputValidity("submit")), 5)
}, { deep: true });

watch(() => props.categoryId, () => {
  if (props.categoryId) {
    podcastCategory.value = podcastCategoryStore.podcastCategories.find(podcastCategory => podcastCategory.id === props.categoryId);
  } else {
    podcastCategory.value = {};
  }
}, { immediate: true });

const resetForm = () => {
  podcastCategory.value = {
    name: "",
    description: ""
  };
};

onMounted(() => {
  const modalEl = document.getElementById("podcastCatModal");

  modalEl.addEventListener("hidden.bs.modal", () => {
    resetForm();
  });
});

</script>

<style scoped>

</style>